import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import NavBar from "../components/NavBar";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const cleanedEmail = (email || "").trim().toLowerCase();
      const cleanedPassword = (password || "").trim();
      const { data } = await api.post("/auth/login", { email: cleanedEmail, password: cleanedPassword });
      localStorage.setItem("bleak_admin_token", data.access_token);
      toast.success("Authenticated");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950">
      <NavBar />
      <div className="max-w-md mx-auto px-4 py-20">
        <div className="border-2 border-zinc-800 bg-zinc-950 p-8 brutal-shadow">
          <div className="flex items-center gap-2 mb-4">
            <Lock className="w-5 h-5 text-zinc-200" />
            <span className="font-mono-tech text-xs uppercase text-zinc-200">// CONTROL ROOM ACCESS</span>
          </div>
          <h1 className="font-display text-4xl text-zinc-50 uppercase leading-none">Admin Login</h1>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
            <div>
              <label className="font-mono-tech text-xs uppercase text-zinc-400 mb-1 block">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} data-testid="admin-email" className="w-full bg-zinc-900 border-2 border-zinc-800 focus:border-zinc-300 focus:outline-none px-3 py-2 font-mono-tech text-sm text-zinc-100" />
            </div>
            <div>
              <label className="font-mono-tech text-xs uppercase text-zinc-400 mb-1 block">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" autoCapitalize="none" autoCorrect="off" spellCheck={false} data-testid="admin-password" className="w-full bg-zinc-900 border-2 border-zinc-800 focus:border-zinc-300 focus:outline-none px-3 py-2 font-mono-tech text-sm text-zinc-100" />
              <div className="mt-1 font-mono-tech text-[10px] text-zinc-500 uppercase">// Password is case-sensitive</div>
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-zinc-300 hover:bg-zinc-200 disabled:opacity-60 text-zinc-950 px-6 py-3 font-display text-lg tracking-widest uppercase brutal-shadow-orange hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-none transition-all">{loading ? "..." : "Authenticate"}</button>
            <div className="text-center">
              <a href="/admin/reset" className="font-mono-tech text-[10px] uppercase tracking-widest text-zinc-500 hover:text-red-400 transition-colors" data-testid="admin-reset-link">// Emergency reset →</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
